import DataStructure, { sanitize } from "./DataStructure.js";
import { uid } from "quasar";
import { compact } from "lodash";
import { deepFreeze, formatCurrency } from "../util/misc.js";
import { highlightDescription } from "./SaleItem.js";

export const CUSTOMER_QUOTE_MATERIAL_ITEM_FIELDS = {
  id: "",
  inventoryID: null,
  itemType: "material",
  line: 0,
  category: "",
  description: "",
  image: null,
  brand: "",
  series: "",
  location: "",
  quantity: 1,
  retail: null,
  price: null,
  notax: false,
};
deepFreeze(CUSTOMER_QUOTE_MATERIAL_ITEM_FIELDS);

export default class CustomerQuoteMaterialItem extends DataStructure {
  constructor(data = {}) {
    data = sanitize(data, CUSTOMER_QUOTE_MATERIAL_ITEM_FIELDS);

    if (!data.id) {
      data.id = uid().slice(-12);
    }

    super(data);
  }

  // Editing

  get isValid() {
    return Boolean(
      this.data.description &&
        this.data.price !== null &&
        this.data.quantity >= 1
    );
  }

  // Formatting

  get retail() {
    return this.data.retail === null ? null : formatCurrency(this.data.retail);
  }

  get price() {
    return this.data.price === null ? null : formatCurrency(this.data.price);
  }

  get total() {
    return formatCurrency(
      this.data.price === null ? 0 : this.data.quantity * this.data.price
    );
  }

  get description() {
    return highlightDescription(this.data.description);
  }

  summary(length = 200) {
    const description = this.data.description.replace(
      /^\*\*+[^*]+\*\*+\s*/gm,
      ""
    );
    return length === null
      ? description
      : description.slice(0, length) + (description.length > length ? "…" : "");
  }

  toString() {
    return compact([
      this.data.brand,
      this.data.series,
      this.data.location,
      this.summary(),
    ]).join("\n");
  }
}
